import { useRef } from 'react';
import { Button, Grid, SvgIcon, Typography } from '@mui/material';
import { Cancel, UploadFile } from '@mui/icons-material';
import Box from '@mui/material/Box';
import { DownloadArea } from './DownloadArea';
import * as React from 'react';

type DroppableFileProps = {
  binaryOrFileUrl: string | File,
  setBinaryOrFileUrl: (binaryOrFileUrl: string | File) => void
}
export const DroppableFile = ({ binaryOrFileUrl, setBinaryOrFileUrl }: DroppableFileProps) => {
  const dropAreaRef = useRef<HTMLDivElement>();
  const inputFile = useRef<HTMLInputElement>(null);
  const dropFileCallback = (files: FileList | null) => {
    if (files && files.length > 0) {
      const [droppedFile] = files;
      if (!/^image\//.test(droppedFile.type)) {
        alert('Unsupported file type, please upload image');
        return;
      }
      setBinaryOrFileUrl(droppedFile);
    }
  };

  return <DownloadArea
    style={{ minHeight: 180 }}
    ref={dropAreaRef}
    draggable
    onDrop={(e) => {
      e.preventDefault();
      dropFileCallback(e.dataTransfer.files);
      dropAreaRef?.current?.removeAttribute('drop-active');
    }}
    onDragOver={(e) => {
      e.preventDefault();
      dropAreaRef?.current?.setAttribute('drop-active', '');
    }}
    onDragLeave={() => dropAreaRef?.current?.removeAttribute('drop-active')}
  >
    {!binaryOrFileUrl &&
      <Grid container>
        <Grid item xs={12}>
          <Typography sx={{ mt: 4, mb: 2, ml: 2, mr: 2, textAlign: 'center' }}>Drag and drop image
            you want to
            upload here, or choose 'Add image'.</Typography>
        </Grid>
        <Grid item xs={12}
              sx={{ display: 'flex', mb: 4, justifyContent: 'center' }}>
          <Button variant={'outlined'} startIcon={<UploadFile/>}
                  onClick={() => inputFile.current?.click()}>
            Add image
            <input
              ref={inputFile}
              type="file"
              onChange={(e) => dropFileCallback(e.target.files)}
              accept="image/*"
              hidden
            />
          </Button>
        </Grid>
      </Grid>}
    { binaryOrFileUrl instanceof File && <Box sx={{ mt: 2, position: 'relative' }}>
      <img src={URL.createObjectURL(binaryOrFileUrl)} alt="logo"
           style={{ width: '100px' }}/>
      <SvgIcon onClick={() => setBinaryOrFileUrl('')}><Cancel
        color="error"/></SvgIcon>
    </Box>}
    { typeof binaryOrFileUrl === 'string' && binaryOrFileUrl.length > 0 && <Box sx={{ mt: 2, position: 'relative' }}>
      <img src={binaryOrFileUrl} alt="logo" style={{ width: '100px' }}/>
      <SvgIcon onClick={() => {
        setBinaryOrFileUrl('')
      }}><Cancel
        color="error"/></SvgIcon>
    </Box>}

  </DownloadArea>;
};